'use client';

import PageTab from '@pc/components/molecules/tab/PageTab';
import PageTabsContainer from '@pc/components/molecules/tab/PageTabsContainer';
import { useRouter } from 'next/navigation';

function PcGuideTabsContainer() {
  const router = useRouter();
  return (
    <PageTabsContainer className='mb-10' contentClassName='w-full'>
      <PageTab
        includedURLPath='/customer/guide/pc/external'
        onClick={() => router.push('/customer/guide/pc/external')}
        isMiddleLine
      >
        외부 앱 방송하기
      </PageTab>
      <PageTab
        includedURLPath='/customer/guide/pc/program'
        onClick={() => router.push('/customer/guide/pc/program')}
        isMiddleLine
      >
        캠 프로그램
      </PageTab>
    </PageTabsContainer>
  );
}

export default PcGuideTabsContainer;
